import { useState } from 'react';

import { trackEvent } from '@/reporting/analytics';
import { Nav } from '@/components/Nav';
import { Footer } from '@/components/Footer';
import { WaitlistModal } from '@/components/waitlist/WaitlistModal';
import { StatusRail } from '@/marketing/StatusRail';
import { Hero } from '@/marketing/Hero';
import { Machine } from '@/marketing/Machine';
import { Mission } from '@/marketing/Mission';
import { GlassBox } from '@/marketing/GlassBox';
import { Access } from '@/marketing/Access';
import { Faq } from '@/marketing/Faq';
import { Cta } from '@/marketing/Cta';

export function App() {
  const [open, setOpen] = useState(false);

  const openWaitlist = (location: string) => {
    trackEvent('cta_click', { cta: 'join_waitlist', location });
    setOpen(true);
  };

  return (
    <>
      <StatusRail />
      <Nav onJoinWaitlist={openWaitlist} />
      <main>
        <Hero onJoinWaitlist={openWaitlist} />
        <Machine />
        <Mission />
        <GlassBox />
        <Access />
        <Faq />
        <Cta onJoinWaitlist={openWaitlist} />
      </main>
      <Footer />
      <WaitlistModal open={open} onOpenChange={setOpen} />
    </>
  );
}
